module.exports = __webpack_public_path__ + "static/media/money.4c215e95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/money.svg
// module id = 2152
// module chunks = 0